import { ComponentPropsWithoutRef, KeyboardEvent } from "react";
import { FieldInputProps } from "formik";
import { Description, Label, Radio, Field } from "@headlessui/react";
import { Key } from "ts-key-enum";
import FormRadio from "components/elements/Forms/FormRadio";
import InputRadio from "components/elements/Input/InputRadio";

export default function SpeckleRadioInputAccounts(
  p: FieldInputProps<string> &
    ComponentPropsWithoutRef<typeof FormRadio> & {
      items: { value: string; label: string; description?: string }[];
      onSelect?(value: string): void;
    },
) {
  const { items, onSelect, ...rest } = p;

  function onClick(value: string) {
    onSelect?.(value);
  }

  function onKeyDown(ev: KeyboardEvent<HTMLDivElement>, value: string) {
    if (ev.key === " " || ev.key === Key.Enter) onSelect?.(value);
  }

  if (!p.items) return null;

  if (p.items.length === 0)
    return <div className="text-center text-sm text-gray-400">None</div>;

  return (
    <InputRadio className="space-y-2" aria-label="Accounts" {...rest}>
      {p.items.map((x) => (
        <Field key={x.value}>
          <div
            className="my-2 select-none rounded-md border p-4 shadow-sm
            hui-checked:border-[#047efb] hui-disabled:text-gray-400 
            hui-not-disabled:cursor-pointer hui-not-disabled:hover:bg-gray-50"
            onClick={() => onClick(x.value)}
            onKeyDown={(ev) => onKeyDown(ev, x.value)}
          >
            <Radio value={x.value}></Radio>
            <Label as="label" className="cursor-[inherit]">
              {x.label}
            </Label>
            {!!x.description && (
              <Description
                as="div"
                className="text-sm font-light text-gray-400"
              >
                {x.description}
              </Description>
            )}
          </div>
        </Field>
      ))}
    </InputRadio>
  );
}
